// Public contact details used across the marketing site and support UI.

import { BOOKING_EMAIL } from '../seo/siteMeta';

export { BOOKING_EMAIL };

/** UK booking office — WhatsApp assistance (E.164 without +). */
export const WHATSAPP_ASSISTANCE_E164 = '447980874179';

export const WHATSAPP_ASSISTANCE_URL = `https://wa.me/${WHATSAPP_ASSISTANCE_E164}`;

export const WHATSAPP_ASSISTANCE_DISPLAY = '+44 7980 874179';

/** UK booking office — primary WhatsApp assist contact (Andy). */
export const WHATSAPP_BOOKING_CONTACT = {
  label: 'Andy',
  hint: 'Booking office',
  e164: WHATSAPP_ASSISTANCE_E164,
  display: WHATSAPP_ASSISTANCE_DISPLAY,
};

/** Nested FAB submenu heading for same-day travel help. */
export const WHATSAPP_DISPATCH_HEADING = 'Delays and pick ups';

/** Nairobi / Arusha office WhatsApp numbers (same-day dispatch). */
export const WHATSAPP_DISPATCH_CONTACTS = [
  { label: 'Nairobi', e164: '254722328595', display: '+254 722 328595' },
  { label: 'Arusha', e164: '255754270089', display: '+255 754 270089' },
];

/** WhatsApp-enabled contacts for the floating assist menu (Andy first). */
export const WHATSAPP_CONTACTS = [
  { ...WHATSAPP_BOOKING_CONTACT, primary: true },
  ...WHATSAPP_DISPATCH_CONTACTS,
];

/**
 * Where privacy and data-protection requests go (src/pages/Privacy.jsx).
 *
 * Points at the booking inbox deliberately: a privacy notice that advertises a
 * privacy@ address nobody has created is worse than one that advertises an
 * address which is actually read, because a subject request has a statutory
 * clock and bouncing it does not stop the clock. Switch this to a dedicated
 * alias once that mailbox exists and someone is watching it.
 */
export const PRIVACY_EMAIL = BOOKING_EMAIL;

/** @deprecated Use BOOKING_EMAIL — kept for existing imports. */
export const SUPPORT_EMAIL = BOOKING_EMAIL;
